//include 28
jQuery(function(){
    
    var templateCache = {};

    var manager = {
        loadTemplate(id){
            if(!templateCache[id]){
                var templateString = $("script#"+id).html();
                templateCache[id] = _.template(templateString);
            }
            return templateCache[id];
        },
        getTemplate(id,data){
            var template = manager.loadTemplate(id);
            if(!template)
                return null;

            var templateData = _.extend({},data,{
                    utilities:window.pixelpoint.utilities
            });
            var result = template(templateData);
            result = _.isFunction(result) ? result(templateData) : result;
            return $(result);
        }
    }

    window.pixelpoint.templateManager = manager;
});